import { tryLoadLightDOMStyles } from '@/components/webcomponents/Global/loadDependency'
import { getNavPortalStyles } from './NavPortal.styles'
import type {} from './types/NavPortal.type'

const t = document.createElement('template')
t.innerHTML = `
  <div class="nav-portal-container">
    <div class="nav-top">
      <slot name="nav-menu-top"></slot>
    </div>
    <div class="nav-bottom">
      <slot name="nav-menu-bottom"></slot>
    </div>
  </div>
`
const TemplateNavPortal = t

class NavPortal extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getNavPortalStyles().content.cloneNode(true))
    shadow.appendChild(TemplateNavPortal.content.cloneNode(true))

    tryLoadLightDOMStyles('NavPortal.css')
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('NavPortal connectedCallback')
    this.updateMobileMenuVisibility()
    // // Measure after first and second paint to avoid transient initial layout values.
    // requestAnimationFrame(() => {
    //   this.updateOffsetTop()
    //   requestAnimationFrame(() => this.updateOffsetTop())
    // })
    // window.addEventListener('load', this._loadHandler)
    // window.addEventListener('resize', this._resizeHandler)
  }

  disconnectedCallback() {
    // window.removeEventListener('load', this._loadHandler)
    // window.removeEventListener('resize', this._resizeHandler)
  }

  // private _loadHandler = () => this.updateOffsetTop()

  // private _resizeHandler = () => this.updateOffsetTop()

  // private updateOffsetTop() {
  //   // Use viewport distance so sticky top/height always map to visible screen space.
  //   const offsetTop = Math.max(this.getBoundingClientRect().top, 0)
  //   this.style.setProperty('--ts-navportal-offset-top', `${offsetTop}px`)
  // }

  static get observedAttributes() {
    return ['mobile-menu-open']
  }

  attributeChangedCallback(name: string) {
    if (name === 'mobile-menu-open') {
      this.updateMobileMenuVisibility()
    }
  }

  updateMobileMenuVisibility() {
    const shadow = this.shadowRoot
    if (!shadow) return

    const container = shadow.querySelector('.nav-portal-container') as HTMLElement | null
    if (!container) return

    const isOpen = this.hasAttribute('mobile-menu-open')
    container.classList.toggle('mobile-menu-open', isOpen)
  }
}

if (!customElements.get('ts-navportal')) {
  customElements.define('ts-navportal', NavPortal)
}
export { NavPortal }
